module.exports = __webpack_public_path__ + "img/c07_unitfishingboat_Normal_ua.b8051a7b.webp";